import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
import * as pageActions from "./pageActions";


export const initPageNews = () => (dispatch) => {
  dispatch(pageActions.loadPageStart());

  return apiActions.loadSingleType(apiValues.nref.pageNews.endpoint)
    .then(result => {
      let page = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.pageNews.fieldsUsed);
      page.intro = {
        title: page.title,
        description: page.description
      };
      return page;
    })
    .then(results => {
      return dispatch(pageActions.loadPageSuccess(results));
    })
};
